import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { toDiscount, usePromocodesStore } from '@pages/promocodes'
import { MAX_PER_PAGE, getFirstQueryValue, toPaginationValue } from '@shared/lib/routes'

import { defineNuxtRouteMiddleware } from '#app'

/**
 * `/promocodes` — query → store filters, mirroring `middleware/users.ts`.
 */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const store = usePromocodesStore()

  store.setFilterSearch(getFirstQueryValue(to.query?.q) || null)
  store.setFilterStatus(getFirstQueryValue(to.query?.status) || null)
  store.setFilterDiscount(toDiscount(getFirstQueryValue(to.query?.discount)))
  store.setFilterFrom(getFirstQueryValue(to.query?.from) || null)
  store.setFilterTo(getFirstQueryValue(to.query?.to) || null)

  store.setCurrentPage(toPaginationValue(to.query?.page, 1))
  store.setPerPage(toPaginationValue(to.query?.per_page, store.getPerPage, MAX_PER_PAGE))
})
